import React, { useState, useEffect, useContext } from "react";
import { Link, navigate } from "gatsby";
import { useMutation } from "@apollo/client";
import { NEW_USER } from "../mutations";
import { toast } from "react-toastify";
import client from "../apollo/client";
import { FilterContext } from "../context/FilterContext";
import textileLibraryLogo from "../images/textile_library_logo.png";
import { tokenMail } from "../services/appenv";
import { sendMailPreRegister } from "../services/api";

// Constants moved outside component to avoid recreation
const EMAIL_REGEX =
  /^(([^<>()[\],;:\s@"]+([^<>()[\],;:\s@"]+)*)|(".+"))@(([^<>()[\],;:\s@"]+)+[^<>()[\],;:\s@"]{2,})$/i;

const generateRandomPassword = () => {
  const charset =
    "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*";
  let password = "";
  for (let i = 0; i < 12; i++) {
    password += charset.charAt(Math.floor(Math.random() * charset.length));
  }
  return password;
};

const INITIAL_STATE = {
  firstname: "",
  lastname: "",
  companyName: "",
  email: "",
  messageError: {},
};

const RegisterShowRoom = () => {
  const { setDataProductsFilter, setTempDataFilter } =
    useContext(FilterContext);
  const [register, setRegister] = useState(INITIAL_STATE);
  const { messageError } = register;

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      navigate("/products");
    } else {
      client.clearStore();
      localStorage.removeItem("token");
    }

    return () => {
      setDataProductsFilter([]);
      setTempDataFilter([]);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const formValidate = (errors, data) => {
    let valid = true;
    Object.values(errors).forEach((val) => {
      val && (valid = false);
    });
    // Check required fields only (excluding companyName which is optional)
    const { firstname, lastname, email } = data;
    [firstname, lastname, email].forEach((val) => {
      val === "" && (valid = false);
    });
    return valid;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let errors = { ...register.messageError };

    switch (name) {
      case "firstname":
        errors.firstname = value === "" ? "This field is required" : "";
        break;
      case "lastname":
        errors.lastname = value === "" ? "This field is required" : "";
        break;
      case "email":
        errors.email =
          value === ""
            ? "This field is required"
            : EMAIL_REGEX.test(value)
            ? ""
            : "This is not a valid email";
        break;
      default:
        break;
    }

    setRegister((prevState) => ({
      ...prevState,
      [name]: value,
      messageError: errors,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formValidate(register.messageError, register)) {
      handleRegisterUser();
      e.target.reset();
    } else {
      toast.error("Please complete the form");
    }
  };

  const handleSendEmail = async () => {
    const dataPreRegister = {
      email: register.email,
      firstName: register.firstname,
      lastName: register.lastname,
      companyName: register.companyName,
      typecustomer: "Special_customer",
      registrationform: "LA_showroom",      
    };

    try {
      await sendMailPreRegister(dataPreRegister, tokenMail);
    } catch (error) {
      
    }
  };

  const handleRegisterUser = () => {
    const randomPassword = generateRandomPassword();

    addUser({
      variables: {
        data: {
          firstName: register.firstname,
          lastName: register.lastname,
          password: randomPassword,
          username: register.email,
          email: register.email,
          companyName: register.companyName,
          role: 1,
          confirmed: true,
          typecustomer: "Special_customer",
          registrationform: "LA_Showroom_Form",
          blocked: false,
        },
      },
    });
  };

  const [addUser] = useMutation(NEW_USER, {
    onCompleted: () => {
      toast.success("Your registration was completed successfully");
      setRegister(INITIAL_STATE);
      handleSendEmail();

      navigate("/successful-registration");
    },
    onError: (error) => {
      toast.error("The user is already registered");
    },
  });

  return (
    <div className="home-flex-content">
      <div className="home-page">
        <div className="home-page__text">
          <img src={textileLibraryLogo} alt="Textile Library Logo" />
          <h3>LA Showroom Registration</h3>
        </div>

        <form noValidate className="home-page__form" onSubmit={handleSubmit}>
          <div className="u-position-relative">
            <input
              type="email"
              name="email"
              value={register.email}
              onChange={handleChange}
              onBlur={handleChange}
              className={messageError.email ? "border-error" : ""}
              placeholder="Email Address *"
            />
            {messageError.email && (
              <small className="field-error field-error-home">
                {messageError.email}
              </small>
            )}
          </div>

          <div className="u-position-relative">
            <input
              type="text"
              name="companyName"
              value={register.companyName}
              onChange={handleChange}
              onBlur={handleChange}
              placeholder="Company / Brand Name"
            />
          </div>

          <div className="fields-group-name-lastname">
            <div className="u-position-relative">
              <input
                type="text"
                name="firstname"
                value={register.firstname}
                onChange={handleChange}
                onBlur={handleChange}
                className={messageError.firstname ? "border-error" : ""}
                placeholder="First Name*"
              />
              {messageError.firstname && (
                <small className="field-error field-error-home">
                  {messageError.firstname}
                </small>
              )}
            </div>
            <div className="u-position-relative">
              <input
                type="text"
                name="lastname"
                value={register.lastname}
                onChange={handleChange}
                onBlur={handleChange}
                className={messageError.lastname ? "border-error" : ""}
                placeholder="Last Name *"
              />
              {messageError.lastname && (
                <small className="field-error field-error-home">
                  {messageError.lastname}
                </small>
              )}
            </div>
          </div>

          <button
            type="submit"
            className="u-text-uppercase btn btn-primary btn-submit"
          >
            Submit
          </button>
        </form>

        <p className="home-page__link">
          <Link to="/login">LOGIN</Link>
        </p>
      </div>
    </div>
  );
};

export default RegisterShowRoom;
